export default "__VITE_ASSET__B$$RP2DB__"